export default {
    'reports': 'التقارير',
    'double-visits': 'الزيارات المزدوجة',
    'visits': 'الزيارات'
}